import apiClient from './config'

/**
 * 产品相关API服务
 */
export const productsAPI = {
  /**
   * 获取所有产品列表
   * @param {Object} params - 查询参数
   * @param {string} params.category - 产品分类（可选）
   * @param {string} params.search - 搜索关键词（可选）
   * @param {boolean} params.is_featured - 是否推荐产品（可选）
   * @returns {Promise} 产品列表
   */
  async getProducts(params = {}) {
    try {
      const response = await apiClient.get('/products', { params })
      return response
    } catch (error) {
      console.error('获取产品列表失败:', error.message)
      throw error
    }
  },

  /**
   * 根据ID获取单个产品
   * @param {number} productId - 产品ID
   * @returns {Promise} 产品详情
   */
  async getProductById(productId) {
    try {
      const response = await apiClient.get(`/products/${productId}`)
      return response
    } catch (error) {
      console.error('获取产品详情失败:', error.message)
      throw error
    }
  },

  /**
   * 添加新产品
   * @param {Object} productData - 产品数据
   * @param {string} productData.name - 产品名称
   * @param {string} productData.category - 产品分类
   * @param {string} productData.description - 产品描述
   * @param {number} productData.price - 产品价格
   * @param {string} productData.image_url - 产品图片URL（可选）
   * @returns {Promise} 创建结果
   */
  async createProduct(productData) {
    const response = await apiClient.post('/products', productData)
    return response
  },

  /**
   * 更新产品信息
   * @param {number} productId - 产品ID
   * @param {Object} productData - 更新的产品数据
   * @returns {Promise} 更新结果
   */
  async updateProduct(productId, productData) {
    try {
      const response = await apiClient.put(`/products/${productId}`, productData)
      return response
    } catch (error) {
      console.error('更新产品失败:', error.message)
      throw error
    }
  },

  /**
   * 删除产品
   * @param {number} productId - 产品ID
   * @returns {Promise} 删除结果
   */
  async deleteProduct(productId) {
    try {
      const response = await apiClient.delete(`/products/${productId}`)
      return response
    } catch (error) {
      console.error('删除产品失败:', error.message)
      throw error
    }
  },

  /**
   * 上传产品图片（单个文件）
   * @param {File} imageFile - 图片文件
   * @returns {Promise} 上传结果
   */
  async uploadProductImage(imageFile) {
    try {
      const formData = new FormData()
      formData.append('file', imageFile)
      
      // 重要：不要手动设置 Content-Type，让浏览器自动设置包含 boundary 的 multipart/form-data
      const response = await apiClient.post('/products/upload-image', formData, {
        timeout: 60000 // 图片上传设置60秒超时
      })
      return response
    } catch (error) {
      console.error('上传产品图片失败:', error)
      throw error
    }
  },

  /**
   * 上传多个产品图片
   * @param {File[]} imageFiles - 图片文件数组
   * @returns {Promise} 上传结果
   */
  async uploadProductImages(imageFiles) {
    try {
      const formData = new FormData()
      
      // 添加所有文件到FormData
      imageFiles.forEach(file => {
        formData.append('files', file)
      })
      
      const response = await apiClient.post('/products/upload-images', formData, {
        timeout: 60000 // 批量图片上传设置60秒超时
      })
      return response
    } catch (error) {
      console.error('批量上传产品图片失败:', error)
      throw error
    }
  },

  /**
   * 获取产品分类列表
   * @returns {Promise} 分类列表
   */
  async getCategories() {
    try {
      const response = await apiClient.get('/products/categories')
      return response
    } catch (error) {
      console.error('获取产品分类失败:', error.message)
      throw error
    }
  }
}

export default productsAPI